<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-info.text-white
				span.fa.fa-search.mr-2
				| Búsqueda de ficheros
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Título
							input.form-control(type="text" v-model="filtro.nombre" placeholder="Buscar por título" @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Fecha de creación
							.input-group
								datepicker(
									:monday-first="true"
									:bootstrap-styling="true"
									:style="{ cursor: 'pointer' }"
									format="dd-MM-yyyy"
									:highlighted="{ dates: [new Date()] }"
									v-model="filtro.fecha"
									placeholder="DD-MM-YYYY"
								)
								.input-group-append
									button.btn.btn-danger(v-if="filtro.fecha" @click="filtro.fecha = null")
										span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Buzón
							select.form-control(v-model="filtro.buzon")
								option(:value="null") Selecciona un buzón
								option(v-for="buzon in listadoBuzones" :key="buzon.ID" :value="buzon.ID") {{ buzon.titulo }}
			.card-footer
				button.btn.btn-primary.mr-2(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar


		.card.mt-3
			.card-header.bg-dark.text-white
				span.fa.fa-list.mr-2
				| Resultados
			.table-responsive(v-if="listadoFicheros.length > 0")
				table.table.table-striped.m-0
					thead
						tr
							th Buzón
							th Nombre
							th Duración
							th Fecha
							th
					tbody

						tr(v-for="fichero in listadoFicheros" :key="fichero.ID")
							td {{ fichero.buzon }}
							td {{ fichero.nombre }}
							td {{ new Date((fichero.duracion - 3600) * 1000).toLocaleTimeString() }}
							td {{ fichero.Fecha }} a las {{ fichero.Hora }}
							td
								a.btn.btn-primary(:href="'/src/modulos/descargar-xframe/php/descargar.php?ID=' + fichero.ID" target="_blank")
									span.fa.fa-download
			.text-center.pt-4.pb-4(v-if="listadoFicheros.length === 0")
				h3 No hay resultados

</template>

<style>
.form-group .vdp-datepicker .input-group > input {
  background-color: white !important;
}
</style>

<script>
import API from './api'

export default {
	data () {
		return {
			listadoBuzones: [],
			listadoFicheros: [],
			filtro: {
				nombre: '',
				fecha: null,
				buzon: null
			},
			buscando: false
		}
	},

	created () {
		this.getBuzones()
	},

	methods: {
		getBuzones () {
			API.getBuzones()
				.then(res => {
					this.listadoBuzones = res.data.buzones
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		buscar () {
			if (this.filtro.buzon === null && this.filtro.nombre.trim() === '' && this.filtro.fecha === null) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes filtrar al menos por un campo'
				})
				return
			}

			this.buscando = true

			API.buscar(this.filtro)
				.then(res => {
					this.listadoFicheros = res.data.ficheros
					this.buscando = false
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
					this.buscando = false
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/descargar-xframe/vue/App.vue